import React from "react";
import WriteToUs from "../../Components/WriteToUs";
import Team from "../Team";
import HelmetSco from "../HelmetSco";

const OurStory = () => {
  const backgroundUrl = "/img/alphaiimage.jpg";
  return (
    <>
    <HelmetSco title={"Alphai Solutions - Our Journey in IT Innovation"} description={"Discover Alphai Solutions' journey in delivering innovative IT services and management solutions, driven by a passion for technology and client success."} imag={backgroundUrl}  />

      <section
        className="mainBanner-module--main_banner--b7162"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
      >
        <div className="container">
          <div className="mainBanner-module--banner_wrap--7f8d1">
            <div className="mainBanner-module--banner_info--c335d">
              <h1
                className="mainBanner-module--ptSans--746de"
                data-aos="fade-up"
                data-aos-delay="50"
              >
                <span> Alphai Innovative Solutions</span>
              </h1>
              {/* <a
                target="_self"
                className="linkButtonRed-module--btn_red--0ea81 undefined"
                href="/contactus"
              >
                Get Started
              </a> */}
            </div>
          </div>
        </div>
      </section>
      <section className="features-module--features_section--26167">
        <div className="container">
          <div className="features-module--features_wrap--87d7d">
            <div className="features-module--features_swipe--0c4c8">
              <span data-aos="fade-up" data-aos-delay="50">
                About
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Alpha Innovative Solutions - Pioneering Tomorrow's Solutions
                Today!
              </h2>
              <p
                data-aos="fade-up"
                data-aos-delay="150"
                style={{ textAlign: "" }}
              >
                In the fast-changing tech landscape, Alphai stands at the
                forefront of innovation as your preferred center. We are
                dedicated to shaping the future through cutting-edge tech
                solutions. Embark on our journey with the Origin of Innovation,
                where Alphai emerged from a shared dream to redefine
                possibilities. Explore Architecting Tomorrow, centered on
                software development and embracing emerging technologies.
              </p>
             

              <p
                data-aos="fade-up"
                data-aos-delay="150"
                style={{ paddingTop: "10px" }}
              >
                Alphai collaborates with Enterprises, SMEs, and Startups,
                offering digital solutions and access to our team of technology
                experts for assistance with software, product, and application
                development. Alphai embodies innovation, collaboration, and an
                unwavering commitment to excellence. Our story is a continual
                evolution, co-created with every client, partner, and team
                member. Join us as we script the upcoming chapters in the
                ever-evolving tech narrative with a purpose.
              </p>
            </div>
            <div
              className="features-module--features_swipe--0c4c8"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="features-module--features_row--686e7">
                <img src="/img/alphai-01.jpg" alt="Your Image Alt Text" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-module--about--50801 undefined">
        <div className="container">
          <div className="about-module--about_wrap--40dca">
            <div className="about-module--about_left--b4981">
              <ul
                className="about-module--about_listing--46f9e"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <li>
                  <div className="about-module--about_list_info--27869">
                    <i>
                      <img src="/img/mumtalikati.svg" alt="" width={"48px"} />
                    </i>

                    <h6>Real Estate Management</h6>
                    <p className="pt-2">10,000+ Properties</p>
                  </div>
                </li>
                <li>
                  <div className="about-module--about_list_info--27869">
                    <i>
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M32.0195 20.8067H28.6914C28.2384 20.8067 27.7999 20.8686 27.3825 20.9824C26.5592 19.364 24.8783 18.252 22.9415 18.252H17.0585C15.1217 18.252 13.4408 19.364 12.6175 20.9824C12.2001 20.8686 11.7616 20.8067 11.3086 20.8067H7.98047C5.23424 20.8067 3 23.041 3 25.7872V31.1075C3 32.7553 4.34054 34.0958 5.98828 34.0958H34.0117C35.6595 34.0958 37 32.7553 37 31.1075V25.7872C37 23.041 34.7658 20.8067 32.0195 20.8067ZM12.0781 23.2326V32.1037H5.98828C5.43904 32.1037 4.99219 31.6569 4.99219 31.1076V25.7873C4.99219 24.1395 6.33273 22.799 7.98047 22.799H11.3086C11.579 22.799 11.8409 22.8357 12.0902 22.9034C12.083 23.0124 12.0781 23.1219 12.0781 23.2326ZM25.9297 32.1037H14.0703V23.2325C14.0703 21.5848 15.4108 20.2442 17.0585 20.2442H22.9415C24.5892 20.2442 25.9297 21.5848 25.9297 23.2325V32.1037ZM35.0078 31.1076C35.0078 31.6569 34.561 32.1037 34.0117 32.1037H27.9219V23.2325C27.9219 23.1218 27.917 23.0122 27.9098 22.9033C28.1591 22.8357 28.421 22.7989 28.6914 22.7989H32.0195C33.6673 22.7989 35.0078 24.1395 35.0078 25.7872V31.1076Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M9.64446 11.4004C7.2041 11.4004 5.21875 13.3857 5.21875 15.8261C5.21868 18.2665 7.2041 20.2518 9.64446 20.2518C12.0848 20.2518 14.0702 18.2665 14.0702 15.8261C14.0702 13.3857 12.0848 11.4004 9.64446 11.4004ZM9.64439 18.2596C8.30252 18.2596 7.21087 17.168 7.21087 15.8261C7.21087 14.4842 8.30252 13.3926 9.64439 13.3926C10.9863 13.3926 12.0779 14.4842 12.0779 15.8261C12.0779 17.168 10.9863 18.2596 9.64439 18.2596Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M19.9986 5.90332C16.7383 5.90332 14.0859 8.55572 14.0859 11.816C14.0859 15.0763 16.7383 17.7287 19.9986 17.7287C23.2589 17.7287 25.9113 15.0763 25.9113 11.816C25.9113 8.55578 23.2589 5.90332 19.9986 5.90332ZM19.9986 15.7365C17.8368 15.7365 16.0781 13.9778 16.0781 11.816C16.0781 9.65428 17.8368 7.89551 19.9986 7.89551C22.1604 7.89551 23.9191 9.65421 23.9191 11.816C23.9191 13.9778 22.1604 15.7365 19.9986 15.7365Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M30.3554 11.4004C27.9151 11.4004 25.9297 13.3857 25.9297 15.8261C25.9298 18.2665 27.9151 20.2518 30.3554 20.2518C32.7958 20.2518 34.7811 18.2665 34.7811 15.8261C34.7811 13.3857 32.7958 11.4004 30.3554 11.4004ZM30.3554 18.2596C29.0136 18.2596 27.9219 17.168 27.9219 15.8261C27.9219 14.4842 29.0136 13.3926 30.3554 13.3926C31.6973 13.3926 32.7889 14.4842 32.7889 15.8261C32.7889 17.168 31.6973 18.2596 30.3554 18.2596Z"
                          fill="#323232"
                        ></path>
                      </svg>
                    </i>
                    <h6>ERP User Satisfaction</h6>
                    <p className="pt-2">94%</p>
                  </div>
                </li>
                <li>
                  <div className="about-module--about_list_info--27869">
                    <i>
                      <img
                        src="/img/chatbot.svg"
                        alt="chatbot"
                        width={"50px"}
                      />
                    </i>
                    <h6>AI Chatbot Engagement</h6>
                    <p className="pt-2">50,000+ Queries</p>
                  </div>
                </li>
                <li>
                  <div className="about-module--about_list_info--27869">
                    <i>
                      <img
                        src="/img/web-app-icon.svg"
                        alt="web"
                        width={"50px"}
                      />
                    </i>
                    <h6 className="" style={{ paddingTop: "12px" }}>
                      Web App User Engagement
                    </h6>
                    <p className="pt-2">75% Engagement Rate</p>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="about-module--about_img--a34d0"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <picture>
                <img
                  src="/img/alphai-logo-2.png"
                  alt="17+years"
                  loading="lazy"
                  width="100%"
                  height="100%"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="founder-module--founder--cd600 undefined">
        <div className="container">
          <div className="founder-module--founder_wrap--f75a0">
            <div className="founder-module--founder_heading--5e136">
              <h2 data-aos="fade-up" data-aos-delay="100">
                Brains behind Alphai
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Meet the visionaries behind our mission:
              </p>
            </div>
            <div
              className="founder-module--founder_list_wrap--91748"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <ul className="founder-module--founder_listing--080a9">
                <li>
                  <div className="founder-module--founders_info_wrap--f2e67">
                    <picture data-aos="fade-right" data-aos-delay="250">
                      <img
                        src="/img/Sheikh.png"
                        alt="Mr. Sheikh Harith Al Ghazali"
                        loading="lazy"
                        width="100%"
                      />
                    </picture>
                    <div className="founder-module--founders_info--1618d">
                      <div className="founder-module--founder_top--df7ba">
                        <div className="founder-module--founder_inner_heading--c3243">
                          <h2>Mr. Sheikh Harith Al Ghazali</h2>
                          <strong>Chairman</strong>
                        </div>
                        <ul className="founder-module--founders_social--1919d">
                          <li>
                            <a
                              href="https://www.linkedin.com/in/faheem-aslam-3ba95620/"
                              target="_blank"
                              aria-label="linkedin"
                            >
                              <i>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 0C5.3736 0 0 5.3736 0 12C0 18.6264 5.3736 24 12 24C18.6264 24 24 18.6264 24 12C24 5.3736 18.6264 0 12 0ZM8.51294 18.1406H5.59039V9.34808H8.51294V18.1406ZM7.05176 8.14746H7.03271C6.052 8.14746 5.41772 7.47235 5.41772 6.6286C5.41772 5.76581 6.07141 5.10938 7.07117 5.10938C8.07092 5.10938 8.68616 5.76581 8.7052 6.6286C8.7052 7.47235 8.07092 8.14746 7.05176 8.14746ZM19.051 18.1406H16.1288V13.4368C16.1288 12.2547 15.7057 11.4485 14.6483 11.4485C13.8409 11.4485 13.3601 11.9923 13.1488 12.5173C13.0715 12.7051 13.0527 12.9677 13.0527 13.2305V18.1406H10.1303C10.1303 18.1406 10.1686 10.173 10.1303 9.34808H13.0527V10.593C13.441 9.9939 14.1359 9.14172 15.6865 9.14172C17.6093 9.14172 19.051 10.3984 19.051 13.099V18.1406Z"
                                    fill="#323232"
                                  ></path>
                                </svg>
                              </i>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{ textAlign: "justify" }}
                        data-aos="fade-left"
                        data-aos-delay="250"
                      >
                        <span style={{ fontWeight: "400" }}>
                          At Alphai Solutions, our success story is shaped by
                          the visionary leadership of Sheikh Harith Al Ghazali,
                          our esteemed Chairman. His indispensable role lies in
                          his exceptional leadership prowess, guiding our team
                          towards excellence and positioning us as a prominent
                          IT partner in the industry. His strategic
                          decision-making, cutting-edge tech skills, and
                          profit-driven approach underscore our commitment to
                          high-quality, scalable decentralized applications.
                        </span>
                      </p>
                      
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="founder-module--founder_list_wrap--91748"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <ul className="founder-module--founder_listing--080a9">
                <li>
                  <div className="founder-module--founders_info_wrap--f2e67">
                    <picture data-aos="fade-right" data-aos-delay="250">
                      <img
                        src="/img/1686512694706.jpeg"
                        alt="Faheem Aslam"
                        loading="lazy"
                        width="100%"
                        height="100%"
                      />
                    </picture>
                    <div className="founder-module--founders_info--1618d">
                      <div className="founder-module--founder_top--df7ba">
                        <div className="founder-module--founder_inner_heading--c3243">
                          <h2>Mr. Faheem</h2>
                          <strong>CEO</strong>
                        </div>
                        <ul className="founder-module--founders_social--1919d">
                          <li>
                            <a
                              href="https://www.linkedin.com/in/faheem-aslam-3ba95620/"
                              target="_blank"
                              aria-label="linkedin"
                            >
                              <i>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 0C5.3736 0 0 5.3736 0 12C0 18.6264 5.3736 24 12 24C18.6264 24 24 18.6264 24 12C24 5.3736 18.6264 0 12 0ZM8.51294 18.1406H5.59039V9.34808H8.51294V18.1406ZM7.05176 8.14746H7.03271C6.052 8.14746 5.41772 7.47235 5.41772 6.6286C5.41772 5.76581 6.07141 5.10938 7.07117 5.10938C8.07092 5.10938 8.68616 5.76581 8.7052 6.6286C8.7052 7.47235 8.07092 8.14746 7.05176 8.14746ZM19.051 18.1406H16.1288V13.4368C16.1288 12.2547 15.7057 11.4485 14.6483 11.4485C13.8409 11.4485 13.3601 11.9923 13.1488 12.5173C13.0715 12.7051 13.0527 12.9677 13.0527 13.2305V18.1406H10.1303C10.1303 18.1406 10.1686 10.173 10.1303 9.34808H13.0527V10.593C13.441 9.9939 14.1359 9.14172 15.6865 9.14172C17.6093 9.14172 19.051 10.3984 19.051 13.099V18.1406Z"
                                    fill="#323232"
                                  ></path>
                                </svg>
                              </i>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{ textAlign: "justify" }}
                        data-aos="fade-left"
                        data-aos-delay="250"
                      >
                        <span style={{ fontWeight: "400" }}>
                          As the CEO of Alphai, Mr. Faheem plays a pivotal role
                          in driving the business forward. He is responsible for
                          setting the strategic direction of the company and
                          ensuring that all business activities align with our
                          mission and goals.
                        </span>
                      </p>
                      <p
                        style={{ textAlign: "justify" }}
                        data-aos="fade-left"
                        data-aos-delay="250"
                      >
                        <span style={{ fontWeight: "400" }}>
                          Mr. Faheem stays abreast of the latest technology
                          trends and anticipates and responds to changes in the
                          market. With his deep understanding of the technical
                          aspects of the business, he effectively communicates
                          this knowledge to both employees and customers. Mr.
                          Faheem is critical in identifying new business
                          opportunities, developing relationships with
                          prospective customers, and expanding our customer
                          base.
                        </span>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
             
              {/* <div
                className="founder-module--founder_list_wrap--91748"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="d-flex">
                  <div class="img__wrap">
                    <img class="img__img" src="/img/Kashif.png" />
                    <div class="img__description_layer">
                      <div className="img__description">
                        <div>
                          <p style={{ color: "#fff" }}>
                            Muhammad Kashif Siddiqui
                          </p>
                          <p style={{ color: "#fff" }}>
                            Chairman Advisory Board
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="img__wrap">
                    <img class="img__img" src="/img/adil.jpeg" />
                    <div class="img__description_layer">
                      <div className="img__description">
                        <div>
                          <p style={{ color: "#fff", paddingLeft: "58px" }}>
                            Adil Zaheer
                          </p>
                          <p style={{ color: "#fff" }}>
                            Chief Technology Officer
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="img__wrap">
                    <img className="img__img" src="/img/ibrar.jpeg" />
                    <div className="img__description_layer">
                      <div className="img__description">
                        <div>
                          <p style={{ color: "#fff", paddingLeft: "58px" }}>
                            Hussain Kaif
                          </p>
                          <p style={{ color: "#fff" }}>
                            Chief Marketing Officer
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="img__wrap">
                    <img className="img__img" src="/img/1555754.png" />
                    <div className="img__description_layer">
                      <div className="img__description">
                        <div>
                          <p style={{ color: "#fff" }}>
                            Muhammad Iftikhar Ahmed
                          </p>
                          <p style={{ color: "#fff" }}>
                            Country Head (Germany)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            
          </div>
          <Team/>
        </div>
      </section>
      <section className="tservices-module--services--53fa0 bg-white">
        <div className="container">
          <div className="tservices-module--services_wrap--4cec4">
            <div className="tservices-module--services_heading--9ebef">
              <span data-aos="fade-up" data-aos-delay="50">
                VALUES
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Our core values
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Empowering individuals and businesses with innovative, reliable,
                and secure technology solutions
              </p>
            </div>
            <ul
              className="tservices-module--development_listing--d8fb3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <li>
                <div className="tservices-module--development_col--1a3f7">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.9348 5.65505L18.3372 5.24614C18.46 5.12562 18.558 4.98146 18.6254 4.82207C18.6927 4.66268 18.7282 4.49125 18.7297 4.31779C18.7312 4.14432 18.6986 3.97229 18.634 3.81173C18.5694 3.65118 18.4739 3.50531 18.3532 3.38265C18.2325 3.25998 18.0889 3.16297 17.9309 3.09729C17.7729 3.0316 17.6036 2.99854 17.4329 3.00005C17.2622 3.00156 17.0935 3.0376 16.9366 3.10607C16.7797 3.17453 16.6379 3.27406 16.5193 3.39884L13.9479 6.01171C13.7069 6.2567 13.5715 6.58893 13.5715 6.93535C13.5715 7.28177 13.7069 7.61401 13.9479 7.859L16.5193 10.4719C16.7618 10.7098 17.0865 10.8415 17.4236 10.8386C17.7607 10.8356 18.0832 10.6982 18.3216 10.456C18.5599 10.2137 18.6952 9.88606 18.6981 9.54352C18.701 9.20098 18.5714 8.87097 18.3372 8.62457L17.9888 8.27053C21.0064 8.41519 23.8485 9.75408 25.9071 12.0008C27.9657 14.2475 29.0772 17.2236 29.004 20.2924C28.9307 23.3612 27.6785 26.2791 25.5152 28.4218C23.3519 30.5644 20.4492 31.7617 17.4283 31.7576H3.28569C2.9447 31.7576 2.61768 31.8952 2.37657 32.1402C2.13546 32.3852 2 32.7175 2 33.064C2 33.4105 2.13546 33.7428 2.37657 33.9878C2.61768 34.2328 2.9447 34.3705 3.28569 34.3705H17.4283C21.14 34.3815 24.7071 32.9085 27.3589 30.2695C30.0108 27.6305 31.5345 24.0373 31.6011 20.2663C31.6676 16.4952 30.2715 12.8489 27.7145 10.1151C25.1574 7.38118 21.6446 5.77915 17.9348 5.65505Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M37.6236 32.1407L35.0523 29.5279C34.8098 29.2899 34.485 29.1582 34.1479 29.1612C33.8108 29.1642 33.4883 29.3016 33.25 29.5438C33.0116 29.786 32.8764 30.1137 32.8734 30.4562C32.8705 30.7988 33.0001 31.1288 33.2343 31.3752L33.611 31.7579H29.0005C28.6595 31.7579 28.3325 31.8956 28.0914 32.1406C27.8503 32.3856 27.7148 32.7179 27.7148 33.0644C27.7148 33.4109 27.8503 33.7432 28.0914 33.9882C28.3325 34.2332 28.6595 34.3708 29.0005 34.3708H33.611L33.2343 34.7536C33.1115 34.8741 33.0136 35.0183 32.9462 35.1777C32.8788 35.3371 32.8433 35.5085 32.8418 35.6819C32.8404 35.8554 32.8729 36.0274 32.9375 36.188C33.0022 36.3486 33.0976 36.4944 33.2184 36.6171C33.3391 36.7398 33.4826 36.8368 33.6406 36.9024C33.7986 36.9681 33.9679 37.0012 34.1387 36.9997C34.3094 36.9982 34.4781 36.9621 34.6349 36.8937C34.7918 36.8252 34.9337 36.7257 35.0523 36.6009L37.6236 33.988C37.8647 33.743 38.0001 33.4108 38.0001 33.0644C38.0001 32.718 37.8647 32.3857 37.6236 32.1407Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M7.1564 29.1458C7.39517 29.1458 7.62922 29.0782 7.83232 28.9507C8.03543 28.8231 8.19957 28.6406 8.30635 28.4236C8.41313 28.2066 8.45833 27.9637 8.43689 27.722C8.41545 27.4804 8.32821 27.2496 8.18495 27.0555C6.66928 25.0266 5.85125 22.548 5.85657 20.0008C5.8591 17.9393 6.39496 15.9148 7.41042 14.1301C8.42588 12.3455 9.88524 10.8635 11.6422 9.8328C11.9378 9.65955 12.1536 9.37407 12.2421 9.03915C12.3306 8.70423 12.2845 8.34731 12.114 8.0469C11.9435 7.7465 11.6626 7.52722 11.333 7.4373C11.0034 7.34738 10.6521 7.3942 10.3565 7.56744C8.2089 8.82842 6.42519 10.6408 5.18412 12.823C3.94305 15.0051 3.28819 17.4804 3.28519 20.0008C3.27828 23.1136 4.27693 26.1428 6.12785 28.6232C6.24761 28.7855 6.4029 28.9172 6.58142 29.0079C6.75995 29.0986 6.9568 29.1458 7.1564 29.1458Z"
                        fill="#323232"
                      ></path>
                    </svg>
                  </i>
                  <h3>Agility</h3>
                  <p>
                    We respond quickly and effectively to changes in the market
                    and customer needs, adapting their strategies and processes.
                  </p>
                </div>
              </li>
              <li>
                <div className="tservices-module--development_col--1a3f7">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.0072 10.6404C19.2873 10.6404 18.5835 10.4269 17.9849 10.0269C17.3863 9.62693 16.9198 9.05844 16.6443 8.39332C16.3688 7.7282 16.2967 6.99632 16.4371 6.29022C16.5776 5.58413 16.9243 4.93555 17.4333 4.42648C17.9424 3.91742 18.591 3.57075 19.2971 3.43029C20.0032 3.28984 20.735 3.36193 21.4002 3.63743C22.0653 3.91293 22.6338 4.37948 23.0337 4.97808C23.4337 5.57667 23.6472 6.28043 23.6472 7.00035C23.6459 7.96535 23.262 8.89046 22.5797 9.57282C21.8973 10.2552 20.9722 10.6391 20.0072 10.6404ZM20.0072 4.64035C19.5404 4.64035 19.0841 4.77876 18.696 5.03808C18.3079 5.2974 18.0055 5.66599 17.8268 6.09722C17.6482 6.52845 17.6015 7.00297 17.6925 7.46077C17.7836 7.91856 18.0084 8.33907 18.3384 8.66913C18.6685 8.99918 19.089 9.22395 19.5468 9.31501C20.0046 9.40607 20.4791 9.35933 20.9103 9.18071C21.3416 9.00209 21.7101 8.6996 21.9695 8.3115C22.2288 7.9234 22.3672 7.46712 22.3672 7.00035C22.3663 6.3747 22.1174 5.77492 21.675 5.33252C21.2326 4.89011 20.6328 4.6412 20.0072 4.64035Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M26.6157 21.362H13.4017C13.232 21.362 13.0692 21.2946 12.9492 21.1746C12.8291 21.0545 12.7617 20.8917 12.7617 20.722V17.0296C12.7617 14.1552 15.1005 11.8164 17.9749 11.8164H22.0417C24.9161 11.8164 27.2549 14.1552 27.2549 17.0296V20.722C27.2549 20.8916 27.1876 21.0543 27.0677 21.1743C26.9479 21.2943 26.7853 21.3618 26.6157 21.362ZM14.0417 20.082H25.9757V17.0296C25.9746 15.9867 25.5597 14.9868 24.8221 14.2494C24.0846 13.512 23.0846 13.0974 22.0417 13.0964H17.9737C16.9311 13.0979 15.9317 13.5128 15.1946 14.2501C14.4575 14.9875 14.0429 15.987 14.0417 17.0296V20.082Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M22.64 21.3624C22.4703 21.3624 22.3075 21.2949 22.1875 21.1749C22.0674 21.0549 22 20.8921 22 20.7224V17.9164C22 17.7466 22.0674 17.5838 22.1875 17.4638C22.3075 17.3438 22.4703 17.2764 22.64 17.2764C22.8097 17.2764 22.9725 17.3438 23.0925 17.4638C23.2126 17.5838 23.28 17.7466 23.28 17.9164V20.7224C23.28 20.8921 23.2126 21.0549 23.0925 21.1749C22.9725 21.2949 22.8097 21.3624 22.64 21.3624Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M16.64 21.3624C16.4703 21.3624 16.3075 21.2949 16.1875 21.1749C16.0674 21.0549 16 20.8921 16 20.7224V17.9164C16 17.7466 16.0674 17.5838 16.1875 17.4638C16.3075 17.3438 16.4703 17.2764 16.64 17.2764C16.8097 17.2764 16.9725 17.3438 17.0925 17.4638C17.2126 17.5838 17.28 17.7466 17.28 17.9164V20.7224C17.28 20.8921 17.2126 21.0549 17.0925 21.1749C16.9725 21.2949 16.8097 21.3624 16.64 21.3624Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M24.3518 31.2611H17.1718C17.0021 31.2611 16.8393 31.1937 16.7193 31.0737C16.5993 30.9536 16.5318 30.7909 16.5318 30.6211C16.5318 30.4514 16.5993 30.2886 16.7193 30.1686C16.8393 30.0485 17.0021 29.9811 17.1718 29.9811H24.3518C24.7165 29.9749 25.064 29.8257 25.3197 29.5657C25.5754 29.3057 25.7186 28.9556 25.7186 28.5909C25.7186 28.2262 25.5754 27.8762 25.3197 27.6161C25.064 27.3561 24.7165 27.2069 24.3518 27.2007H17.1542C17.0938 27.2007 15.6554 27.1507 13.8594 26.3727L13.7466 26.3235C12.0762 25.5907 10.849 25.2167 10.0994 25.2119C8.89063 25.2043 7.85463 25.4519 7.02343 25.9447C6.95117 25.9887 6.87092 26.0179 6.7873 26.0306C6.70369 26.0434 6.61838 26.0394 6.5363 26.019C6.45423 25.9986 6.37701 25.9621 6.30911 25.9117C6.24122 25.8613 6.184 25.7979 6.14075 25.7252C6.09751 25.6525 6.0691 25.5719 6.05718 25.4882C6.04525 25.4045 6.05004 25.3192 6.07126 25.2373C6.09249 25.1555 6.12974 25.0786 6.18085 25.0112C6.23195 24.9438 6.29591 24.8872 6.36903 24.8447C7.40343 24.2295 8.66023 23.9211 10.1078 23.9319C11.357 23.9403 13.0762 24.6319 14.2606 25.1511L14.3686 25.1983C15.8642 25.8463 17.0818 25.9159 17.1842 25.9207H24.3518C25.0544 25.9293 25.7252 26.2144 26.2189 26.7142C26.7127 27.2141 26.9895 27.8883 26.9895 28.5909C26.9895 29.2935 26.7127 29.9678 26.2189 30.4676C25.7252 30.9674 25.0544 31.2525 24.3518 31.2611Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M19.9447 36.6402C19.641 36.6402 19.3356 36.6259 19.0287 36.5974C17.963 36.4945 16.9209 36.2202 15.9427 35.785L13.2859 34.6138C12.4771 34.2561 11.6476 33.947 10.8019 33.6882C10.1995 33.505 9.88189 33.4394 9.72189 33.4166C8.42469 33.2318 7.43029 33.2362 6.92189 33.4294C6.82487 33.4663 6.72035 33.4789 6.61733 33.4664C6.51431 33.4539 6.41589 33.4165 6.33054 33.3574C6.2452 33.2984 6.1755 33.2194 6.12744 33.1275C6.07938 33.0355 6.05442 32.9332 6.05469 32.8294V25.357C6.05469 25.1873 6.12212 25.0245 6.24214 24.9045C6.36216 24.7844 6.52495 24.717 6.69469 24.717C6.86443 24.717 7.02721 24.7844 7.14724 24.9045C7.26726 25.0245 7.33469 25.1873 7.33469 25.357V32.0402C8.00829 31.9658 8.86709 32.0026 9.90269 32.1502C10.2055 32.193 10.6227 32.2958 11.1751 32.4642C12.0699 32.7378 12.9475 33.0648 13.8031 33.4434L16.4603 34.6142C17.3124 34.9942 18.2204 35.2338 19.1491 35.3238C19.8445 35.3903 20.5455 35.3686 21.2355 35.259C22.1123 35.1174 23.4031 34.6814 23.8887 34.5174L23.9715 34.4894C28.8243 32.8626 33.2195 28.4894 34.8839 26.6894C35.081 26.4798 35.2233 26.2248 35.2981 25.947C35.373 25.6692 35.3782 25.3773 35.3131 25.097C35.2259 24.7334 35.0035 24.2418 34.0859 24.167C33.6697 24.135 33.2558 24.2523 32.9183 24.4978L26.7515 28.9494C26.6835 29.0003 26.606 29.0372 26.5236 29.0579C26.4411 29.0785 26.3554 29.0826 26.2714 29.0697C26.1874 29.0569 26.1068 29.0275 26.0343 28.9832C25.9618 28.9389 25.8988 28.8806 25.8491 28.8117C25.7993 28.7428 25.7638 28.6647 25.7446 28.5819C25.7253 28.4992 25.7228 28.4134 25.737 28.3296C25.7513 28.2459 25.7821 28.1658 25.8276 28.094C25.8732 28.0223 25.9326 27.9604 26.0023 27.9118L32.1695 23.4602C32.7533 23.0356 33.4694 22.8331 34.1891 22.889C35.4447 22.9914 36.2855 23.6686 36.5563 24.795C36.6708 25.2799 36.6638 25.7855 36.5359 26.267C36.408 26.7485 36.1631 27.1909 35.8231 27.555C34.0919 29.4314 29.5111 33.981 24.3775 35.7022L24.2975 35.7294C23.7839 35.9026 22.4199 36.3634 21.4383 36.5202C20.9444 36.5999 20.445 36.6401 19.9447 36.6402Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M5.35497 35.4425C4.82594 35.442 4.31872 35.2316 3.9446 34.8576C3.57048 34.4835 3.36001 33.9764 3.35938 33.4473V24.4317C3.35938 23.9026 3.56958 23.3951 3.94376 23.0209C4.31793 22.6467 4.82542 22.4365 5.35458 22.4365C5.88374 22.4365 6.39122 22.6467 6.76539 23.0209C7.13957 23.3951 7.34977 23.9026 7.34977 24.4317V33.4473C7.34925 33.9763 7.13892 34.4834 6.76495 34.8574C6.39098 35.2315 5.8839 35.4419 5.35497 35.4425ZM5.35497 23.7169C5.16536 23.717 4.98352 23.7923 4.84937 23.9264C4.71521 24.0604 4.63969 24.2421 4.63937 24.4317V33.4473C4.63937 33.637 4.71473 33.8189 4.84885 33.953C4.98298 34.0872 5.16489 34.1625 5.35458 34.1625C5.54426 34.1625 5.72617 34.0872 5.8603 33.953C5.99442 33.8189 6.06977 33.637 6.06977 33.4473V24.4317C6.06956 24.2422 5.99419 24.0605 5.86018 23.9265C5.72618 23.7925 5.54449 23.7171 5.35497 23.7169Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                    </svg>
                  </i>
                  <h3>Talent Solution</h3>
                  <h5>Client-first</h5>
                  <p>
                    We prioritize our customers and work to deliver high-quality
                    products and services that meet their needs and exceed their
                    expectations.
                  </p>
                </div>
              </li>
              <li>
                <div className="tservices-module--development_col--1a3f7">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3276_28149"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="2"
                        y="2"
                        width="36"
                        height="36"
                      >
                        <path d="M2 2H38V38H2V2Z" fill="white"></path>
                      </mask>
                      <g mask="url(#mask0_3276_28149)">
                        <path
                          d="M30.5469 20C30.5469 25.8249 25.8249 30.5469 20 30.5469C14.1751 30.5469 9.45312 25.8249 9.45312 20C9.45312 14.1751 14.1751 9.45312 20 9.45312C25.8249 9.45312 30.5469 14.1751 30.5469 20Z"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M25.2734 16.8359L18.9453 23.1641L14.7266 18.9453"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M18.6321 3.5583C19.4205 2.88681 20.5795 2.88681 21.3679 3.5583L24.1089 5.9774L28.7473 5.61846C29.7798 5.53858 30.7175 6.21984 30.9605 7.22643L31.8905 11.0779L35.9432 13.5038C36.8254 14.046 37.1836 15.1484 36.7886 16.1056L35.1875 19.9852L36.7886 23.8648C37.1836 24.8221 36.8254 25.9244 35.9432 26.4667L31.8905 28.8926L30.9605 32.744C30.7175 33.7506 29.7798 34.4319 28.7473 34.352L24.1542 33.9965L21.3679 36.4417C20.5795 37.1132 19.4205 37.1132 18.6321 36.4417L15.8458 33.9965L11.2527 34.352C10.2202 34.4319 9.28248 33.7506 9.03948 32.744L8.1058 28.8773L4.05987 26.4667C3.17759 25.9244 2.81942 24.8221 3.21451 23.8648L4.81552 19.9852L3.21451 16.1056C2.81942 15.1484 3.17759 14.046 4.05987 13.5038L7.75902 11.3062L9.03948 7.22643C9.28248 6.21984 10.2202 5.53858 11.2527 5.61846L15.8912 5.9774L18.6321 3.5583Z"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </g>
                    </svg>
                  </i>
                  <h3>Integrity &amp; Quality</h3>
                  <p>
                    We hold a high value on honesty, transparency, high quality,
                    and ethical behavior within the company and with customers
                    and partners.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* <section className="ourPresence-module--presence--8a6d9 undefined">
        <div className="container">
          <div className="ourPresence-module--presence_wrap--1b136">
            <div className="ourPresence-module--mix_heading--3e1da">
              <span data-aos="fade-up" data-aos-delay="50">
                VALUES
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Our core values
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Empowering individuals and businesses with innovative, reliable,
                and secure technology solutions
              </p>
            </div>
            <div
              className="ourPresence-module--presence_right--9bc85"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="ourPresence-module--presence_vertical--b10df">
                <div className="ourPresence-module--presence_col--25ea6">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.9348 5.65505L18.3372 5.24614C18.46 5.12562 18.558 4.98146 18.6254 4.82207C18.6927 4.66268 18.7282 4.49125 18.7297 4.31779C18.7312 4.14432 18.6986 3.97229 18.634 3.81173C18.5694 3.65118 18.4739 3.50531 18.3532 3.38265C18.2325 3.25998 18.0889 3.16297 17.9309 3.09729C17.7729 3.0316 17.6036 2.99854 17.4329 3.00005C17.2622 3.00156 17.0935 3.0376 16.9366 3.10607C16.7797 3.17453 16.6379 3.27406 16.5193 3.39884L13.9479 6.01171C13.7069 6.2567 13.5715 6.58893 13.5715 6.93535C13.5715 7.28177 13.7069 7.61401 13.9479 7.859L16.5193 10.4719C16.7618 10.7098 17.0865 10.8415 17.4236 10.8386C17.7607 10.8356 18.0832 10.6982 18.3216 10.456C18.5599 10.2137 18.6952 9.88606 18.6981 9.54352C18.701 9.20098 18.5714 8.87097 18.3372 8.62457L17.9888 8.27053C21.0064 8.41519 23.8485 9.75408 25.9071 12.0008C27.9657 14.2475 29.0772 17.2236 29.004 20.2924C28.9307 23.3612 27.6785 26.2791 25.5152 28.4218C23.3519 30.5644 20.4492 31.7617 17.4283 31.7576H3.28569C2.9447 31.7576 2.61768 31.8952 2.37657 32.1402C2.13546 32.3852 2 32.7175 2 33.064C2 33.4105 2.13546 33.7428 2.37657 33.9878C2.61768 34.2328 2.9447 34.3705 3.28569 34.3705H17.4283C21.14 34.3815 24.7071 32.9085 27.3589 30.2695C30.0108 27.6305 31.5345 24.0373 31.6011 20.2663C31.6676 16.4952 30.2715 12.8489 27.7145 10.1151C25.1574 7.38118 21.6446 5.77915 17.9348 5.65505Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M37.6236 32.1407L35.0523 29.5279C34.8098 29.2899 34.485 29.1582 34.1479 29.1612C33.8108 29.1642 33.4883 29.3016 33.25 29.5438C33.0116 29.786 32.8764 30.1137 32.8734 30.4562C32.8705 30.7988 33.0001 31.1288 33.2343 31.3752L33.611 31.7579H29.0005C28.6595 31.7579 28.3325 31.8956 28.0914 32.1406C27.8503 32.3856 27.7148 32.7179 27.7148 33.0644C27.7148 33.4109 27.8503 33.7432 28.0914 33.9882C28.3325 34.2332 28.6595 34.3708 29.0005 34.3708H33.611L33.2343 34.7536C33.1115 34.8741 33.0136 35.0183 32.9462 35.1777C32.8788 35.3371 32.8433 35.5085 32.8418 35.6819C32.8404 35.8554 32.8729 36.0274 32.9375 36.188C33.0022 36.3486 33.0976 36.4944 33.2184 36.6171C33.3391 36.7398 33.4826 36.8368 33.6406 36.9024C33.7986 36.9681 33.9679 37.0012 34.1387 36.9997C34.3094 36.9982 34.4781 36.9621 34.6349 36.8937C34.7918 36.8252 34.9337 36.7257 35.0523 36.6009L37.6236 33.988C37.8647 33.743 38.0001 33.4108 38.0001 33.0644C38.0001 32.718 37.8647 32.3857 37.6236 32.1407Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M7.1564 29.1458C7.39517 29.1458 7.62922 29.0782 7.83232 28.9507C8.03543 28.8231 8.19957 28.6406 8.30635 28.4236C8.41313 28.2066 8.45833 27.9637 8.43689 27.722C8.41545 27.4804 8.32821 27.2496 8.18495 27.0555C6.66928 25.0266 5.85125 22.548 5.85657 20.0008C5.8591 17.9393 6.39496 15.9148 7.41042 14.1301C8.42588 12.3455 9.88524 10.8635 11.6422 9.8328C11.9378 9.65955 12.1536 9.37407 12.2421 9.03915C12.3306 8.70423 12.2845 8.34731 12.114 8.0469C11.9435 7.7465 11.6626 7.52722 11.333 7.4373C11.0034 7.34738 10.6521 7.3942 10.3565 7.56744C8.2089 8.82842 6.42519 10.6408 5.18412 12.823C3.94305 15.0051 3.28819 17.4804 3.28519 20.0008C3.27828 23.1136 4.27693 26.1428 6.12785 28.6232C6.24761 28.7855 6.4029 28.9172 6.58142 29.0079C6.75995 29.0986 6.9568 29.1458 7.1564 29.1458Z"
                        fill="#323232"
                      ></path>
                    </svg>
                  </i>
                  <h5>Agility</h5>
                  <p>
                    We respond quickly and effectively to changes in the market
                    and customer needs, adapting their strategies and processes.
                  </p>
                </div>
                <div className="ourPresence-module--presence_col--25ea6">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.0072 10.6404C19.2873 10.6404 18.5835 10.4269 17.9849 10.0269C17.3863 9.62693 16.9198 9.05844 16.6443 8.39332C16.3688 7.7282 16.2967 6.99632 16.4371 6.29022C16.5776 5.58413 16.9243 4.93555 17.4333 4.42648C17.9424 3.91742 18.591 3.57075 19.2971 3.43029C20.0032 3.28984 20.735 3.36193 21.4002 3.63743C22.0653 3.91293 22.6338 4.37948 23.0337 4.97808C23.4337 5.57667 23.6472 6.28043 23.6472 7.00035C23.6459 7.96535 23.262 8.89046 22.5797 9.57282C21.8973 10.2552 20.9722 10.6391 20.0072 10.6404ZM20.0072 4.64035C19.5404 4.64035 19.0841 4.77876 18.696 5.03808C18.3079 5.2974 18.0055 5.66599 17.8268 6.09722C17.6482 6.52845 17.6015 7.00297 17.6925 7.46077C17.7836 7.91856 18.0084 8.33907 18.3384 8.66913C18.6685 8.99918 19.089 9.22395 19.5468 9.31501C20.0046 9.40607 20.4791 9.35933 20.9103 9.18071C21.3416 9.00209 21.7101 8.6996 21.9695 8.3115C22.2288 7.9234 22.3672 7.46712 22.3672 7.00035C22.3663 6.3747 22.1174 5.77492 21.675 5.33252C21.2326 4.89011 20.6328 4.6412 20.0072 4.64035Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M26.6157 21.362H13.4017C13.232 21.362 13.0692 21.2946 12.9492 21.1746C12.8291 21.0545 12.7617 20.8917 12.7617 20.722V17.0296C12.7617 14.1552 15.1005 11.8164 17.9749 11.8164H22.0417C24.9161 11.8164 27.2549 14.1552 27.2549 17.0296V20.722C27.2549 20.8916 27.1876 21.0543 27.0677 21.1743C26.9479 21.2943 26.7853 21.3618 26.6157 21.362ZM14.0417 20.082H25.9757V17.0296C25.9746 15.9867 25.5597 14.9868 24.8221 14.2494C24.0846 13.512 23.0846 13.0974 22.0417 13.0964H17.9737C16.9311 13.0979 15.9317 13.5128 15.1946 14.2501C14.4575 14.9875 14.0429 15.987 14.0417 17.0296V20.082Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M22.64 21.3624C22.4703 21.3624 22.3075 21.2949 22.1875 21.1749C22.0674 21.0549 22 20.8921 22 20.7224V17.9164C22 17.7466 22.0674 17.5838 22.1875 17.4638C22.3075 17.3438 22.4703 17.2764 22.64 17.2764C22.8097 17.2764 22.9725 17.3438 23.0925 17.4638C23.2126 17.5838 23.28 17.7466 23.28 17.9164V20.7224C23.28 20.8921 23.2126 21.0549 23.0925 21.1749C22.9725 21.2949 22.8097 21.3624 22.64 21.3624Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M16.64 21.3624C16.4703 21.3624 16.3075 21.2949 16.1875 21.1749C16.0674 21.0549 16 20.8921 16 20.7224V17.9164C16 17.7466 16.0674 17.5838 16.1875 17.4638C16.3075 17.3438 16.4703 17.2764 16.64 17.2764C16.8097 17.2764 16.9725 17.3438 17.0925 17.4638C17.2126 17.5838 17.28 17.7466 17.28 17.9164V20.7224C17.28 20.8921 17.2126 21.0549 17.0925 21.1749C16.9725 21.2949 16.8097 21.3624 16.64 21.3624Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M24.3518 31.2611H17.1718C17.0021 31.2611 16.8393 31.1937 16.7193 31.0737C16.5993 30.9536 16.5318 30.7909 16.5318 30.6211C16.5318 30.4514 16.5993 30.2886 16.7193 30.1686C16.8393 30.0485 17.0021 29.9811 17.1718 29.9811H24.3518C24.7165 29.9749 25.064 29.8257 25.3197 29.5657C25.5754 29.3057 25.7186 28.9556 25.7186 28.5909C25.7186 28.2262 25.5754 27.8762 25.3197 27.6161C25.064 27.3561 24.7165 27.2069 24.3518 27.2007H17.1542C17.0938 27.2007 15.6554 27.1507 13.8594 26.3727L13.7466 26.3235C12.0762 25.5907 10.849 25.2167 10.0994 25.2119C8.89063 25.2043 7.85463 25.4519 7.02343 25.9447C6.95117 25.9887 6.87092 26.0179 6.7873 26.0306C6.70369 26.0434 6.61838 26.0394 6.5363 26.019C6.45423 25.9986 6.37701 25.9621 6.30911 25.9117C6.24122 25.8613 6.184 25.7979 6.14075 25.7252C6.09751 25.6525 6.0691 25.5719 6.05718 25.4882C6.04525 25.4045 6.05004 25.3192 6.07126 25.2373C6.09249 25.1555 6.12974 25.0786 6.18085 25.0112C6.23195 24.9438 6.29591 24.8872 6.36903 24.8447C7.40343 24.2295 8.66023 23.9211 10.1078 23.9319C11.357 23.9403 13.0762 24.6319 14.2606 25.1511L14.3686 25.1983C15.8642 25.8463 17.0818 25.9159 17.1842 25.9207H24.3518C25.0544 25.9293 25.7252 26.2144 26.2189 26.7142C26.7127 27.2141 26.9895 27.8883 26.9895 28.5909C26.9895 29.2935 26.7127 29.9678 26.2189 30.4676C25.7252 30.9674 25.0544 31.2525 24.3518 31.2611Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M19.9447 36.6402C19.641 36.6402 19.3356 36.6259 19.0287 36.5974C17.963 36.4945 16.9209 36.2202 15.9427 35.785L13.2859 34.6138C12.4771 34.2561 11.6476 33.947 10.8019 33.6882C10.1995 33.505 9.88189 33.4394 9.72189 33.4166C8.42469 33.2318 7.43029 33.2362 6.92189 33.4294C6.82487 33.4663 6.72035 33.4789 6.61733 33.4664C6.51431 33.4539 6.41589 33.4165 6.33054 33.3574C6.2452 33.2984 6.1755 33.2194 6.12744 33.1275C6.07938 33.0355 6.05442 32.9332 6.05469 32.8294V25.357C6.05469 25.1873 6.12212 25.0245 6.24214 24.9045C6.36216 24.7844 6.52495 24.717 6.69469 24.717C6.86443 24.717 7.02721 24.7844 7.14724 24.9045C7.26726 25.0245 7.33469 25.1873 7.33469 25.357V32.0402C8.00829 31.9658 8.86709 32.0026 9.90269 32.1502C10.2055 32.193 10.6227 32.2958 11.1751 32.4642C12.0699 32.7378 12.9475 33.0648 13.8031 33.4434L16.4603 34.6142C17.3124 34.9942 18.2204 35.2338 19.1491 35.3238C19.8445 35.3903 20.5455 35.3686 21.2355 35.259C22.1123 35.1174 23.4031 34.6814 23.8887 34.5174L23.9715 34.4894C28.8243 32.8626 33.2195 28.4894 34.8839 26.6894C35.081 26.4798 35.2233 26.2248 35.2981 25.947C35.373 25.6692 35.3782 25.3773 35.3131 25.097C35.2259 24.7334 35.0035 24.2418 34.0859 24.167C33.6697 24.135 33.2558 24.2523 32.9183 24.4978L26.7515 28.9494C26.6835 29.0003 26.606 29.0372 26.5236 29.0579C26.4411 29.0785 26.3554 29.0826 26.2714 29.0697C26.1874 29.0569 26.1068 29.0275 26.0343 28.9832C25.9618 28.9389 25.8988 28.8806 25.8491 28.8117C25.7993 28.7428 25.7638 28.6647 25.7446 28.5819C25.7253 28.4992 25.7228 28.4134 25.737 28.3296C25.7513 28.2459 25.7821 28.1658 25.8276 28.094C25.8732 28.0223 25.9326 27.9604 26.0023 27.9118L32.1695 23.4602C32.7533 23.0356 33.4694 22.8331 34.1891 22.889C35.4447 22.9914 36.2855 23.6686 36.5563 24.795C36.6708 25.2799 36.6638 25.7855 36.5359 26.267C36.408 26.7485 36.1631 27.1909 35.8231 27.555C34.0919 29.4314 29.5111 33.981 24.3775 35.7022L24.2975 35.7294C23.7839 35.9026 22.4199 36.3634 21.4383 36.5202C20.9444 36.5999 20.445 36.6401 19.9447 36.6402Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                      <path
                        d="M5.35497 35.4425C4.82594 35.442 4.31872 35.2316 3.9446 34.8576C3.57048 34.4835 3.36001 33.9764 3.35938 33.4473V24.4317C3.35938 23.9026 3.56958 23.3951 3.94376 23.0209C4.31793 22.6467 4.82542 22.4365 5.35458 22.4365C5.88374 22.4365 6.39122 22.6467 6.76539 23.0209C7.13957 23.3951 7.34977 23.9026 7.34977 24.4317V33.4473C7.34925 33.9763 7.13892 34.4834 6.76495 34.8574C6.39098 35.2315 5.8839 35.4419 5.35497 35.4425ZM5.35497 23.7169C5.16536 23.717 4.98352 23.7923 4.84937 23.9264C4.71521 24.0604 4.63969 24.2421 4.63937 24.4317V33.4473C4.63937 33.637 4.71473 33.8189 4.84885 33.953C4.98298 34.0872 5.16489 34.1625 5.35458 34.1625C5.54426 34.1625 5.72617 34.0872 5.8603 33.953C5.99442 33.8189 6.06977 33.637 6.06977 33.4473V24.4317C6.06956 24.2422 5.99419 24.0605 5.86018 23.9265C5.72618 23.7925 5.54449 23.7171 5.35497 23.7169Z"
                        fill="#323232"
                        stroke="#323232"
                        strokeWidth="0.7"
                      ></path>
                    </svg>
                  </i>
                  <h5>Client-first</h5>
                  <p>
                    We prioritize our customers and work to deliver high-quality
                    products and services that meet their needs and exceed their
                    expectations.
                  </p>
                </div>
              </div>
              <div className="ourPresence-module--presence_vertical--b10df">
                <div className="ourPresence-module--presence_col--25ea6">
                  <i>
                    {" "}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3276_28149"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="2"
                        y="2"
                        width="36"
                        height="36"
                      >
                        <path d="M2 2H38V38H2V2Z" fill="white"></path>
                      </mask>
                      <g mask="url(#mask0_3276_28149)">
                        <path
                          d="M30.5469 20C30.5469 25.8249 25.8249 30.5469 20 30.5469C14.1751 30.5469 9.45312 25.8249 9.45312 20C9.45312 14.1751 14.1751 9.45312 20 9.45312C25.8249 9.45312 30.5469 14.1751 30.5469 20Z"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M25.2734 16.8359L18.9453 23.1641L14.7266 18.9453"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M18.6321 3.5583C19.4205 2.88681 20.5795 2.88681 21.3679 3.5583L24.1089 5.9774L28.7473 5.61846C29.7798 5.53858 30.7175 6.21984 30.9605 7.22643L31.8905 11.0779L35.9432 13.5038C36.8254 14.046 37.1836 15.1484 36.7886 16.1056L35.1875 19.9852L36.7886 23.8648C37.1836 24.8221 36.8254 25.9244 35.9432 26.4667L31.8905 28.8926L30.9605 32.744C30.7175 33.7506 29.7798 34.4319 28.7473 34.352L24.1542 33.9965L21.3679 36.4417C20.5795 37.1132 19.4205 37.1132 18.6321 36.4417L15.8458 33.9965L11.2527 34.352C10.2202 34.4319 9.28248 33.7506 9.03948 32.744L8.1058 28.8773L4.05987 26.4667C3.17759 25.9244 2.81942 24.8221 3.21451 23.8648L4.81552 19.9852L3.21451 16.1056C2.81942 15.1484 3.17759 14.046 4.05987 13.5038L7.75902 11.3062L9.03948 7.22643C9.28248 6.21984 10.2202 5.53858 11.2527 5.61846L15.8912 5.9774L18.6321 3.5583Z"
                          stroke="black"
                          strokeWidth="2"
                          stroke-miterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </g>
                    </svg>
                  </i>
                  <h5>Integrity &amp; Quality</h5>
                  <p>
                    We hold a high value on honesty, transparency, high quality,
                    and ethical behavior within the company and with customers
                    and partners.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <WriteToUs />
    </>
  );
};

export default OurStory;
